<template>
  <el-dialog
  :title="'上传作业'"
  width="700px"
  @open="dialogOpen"
  :close-on-click-modal="false"
  :visible.sync="dialogVisible"
  :before-close="handleUploadClose">
    <div class="batch-match-wrap">
      <div style="position: absolute;top: 45px;width: 620px;">
         <el-alert
          close-text="知道了"
          title="温馨提示：可以一次选择多个作业图像文件~"
          type="warning">
        </el-alert>
      </div>
      <div class="import-dialog-container">
        <div class="upload-wrapper">
          <div v-if="files.length===0" class="button-input-file-wrapper">
            <el-button
              type="primary"
              class="button-input-file">
              点击选取作业上传文件
            </el-button>
            <input type="file" ref="fileInput" class="file-input" accept="image/*"  @change="handleChange" multiple>
          </div>
          <div class="file-list-wrap">
            <div class="file-item" v-for="(file,fileIndex) of files" :key="fileIndex">
              <span>{{`${fileIndex+1}.${file.name}`}}</span>
              <i @click="removeFile(fileIndex)" class="el-icon-close"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :disabled="submitDisabled" @click="uploadHomework" :loading="submitLoading">上 传</el-button>
      <el-button type="info" @click="handleUploadClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {batchSubmit} from '@/model/homework-model'
import common from '@/util/common'

export default {
  name: 'UploadHomework',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data () {
    return {
      files: [],
      submitLoading: false
    }
  },
  methods: {
    dialogOpen () {
      this.files.splice(0, this.files.length)
      this.$refs.fileInput.value = ''
      this.fileName = '点击选择文件'
    },
    removeFile (fileIndex) {
      console.log(this.files)
      this.files.splice(fileIndex, 1)
    },
    initData () {
      this.files.splice(0, this.files.length)
      this.$refs.fileInput.value = ''
      this.fileName = '点击选择文件'
    },
    handleChange () {
      console.log(this.$refs.fileInput.files)
      let files = this.$refs.fileInput.files
      if (files) {
        this.files.splice(0, this.files.length)
        for (let file of files) {
          this.files.push(file)
        }
      }
    },
    uploadHomework () {
      this.submitLoading = true
      let formData = new FormData()
      for (let file of this.files) {
        formData.append('files', file)
      }
      batchSubmit({
        formData: formData,
        taskId: this.taskId
      }).then(res => {
        this.submitLoading = false
        if (res.result.toString() === 'true') {
          // 导入成功
          this.$message({
            message: '操作成功.',
            type: 'success'
          })
          this.handleUploadClose()
        } else {
          this.$message.error('上传失败.')
        }
      }).catch(e => {
        this.submitLoading = false
        this.$message.error('上传失败.')
      })
    },
    handleUploadClose (done) {
      this.$emit('dialog-close', 'UploadHomework')
    }
  },
  created () {
  },
  mounted () {

  },
  computed: {
    userInfo () {
      return common.getUserInfo()
    },
    submitDisabled () {
      return this.files.length === 0
    }
  }
}
</script>

<style lang="scss">
.import-candidate{
  .el-dialog{
    margin: 0;
    margin-top: 0 !important;
  }

  .v-modal{
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.batch-match-wrap{
  margin: 0 20px;
}

.import-tips {
  margin: 0 auto;
  width: 580px;
  color: #459146;
  padding-left: 30px;
  background: url("~@/assets/image/bell.png") left center no-repeat;
}
.import-dialog-container {
  box-sizing: border-box;
  width: 100%;
  padding-top: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .upload-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    .file-list-wrap{
      height: 500px;
      overflow-y: auto;
      width: 600px;
      display: flex;
      flex-direction: column;
      .file-item{
        min-height: 40px;
        background-color: #d2dbf333;
        margin-top: 10px;
        font-size: 18px;
        color: #4b380f;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
        i{
          color: #4b380f;
          cursor: pointer;
        }
      }
    }
  }

  .button-input-file-wrapper {
    position: relative;
  }

  .button-input-file {
    background: transparent;
    width: 220px;
    height: 30px;
    padding: 0;
    color: #A78C6F;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 30px;
    // visibility: hidden;
    color:transparent;
    border: none;
    background: transparent;
    opacity: 0;
    z-index: 10;
  }

  .import-model {
    box-sizing: border-box;
    width: 160px;
    height: 70px;
    border-left: 1px solid #CADFE4;
    margin-left: 42px;
    padding-top: 44px;
    text-align: center;
    background: url("~@/assets/image/excel.png") center top no-repeat;

    &.model-link {
      color: #478F43;
    }
  }
}

.import-type-wrap{
  height: 39px;
}
/deep/ .el-dialog__header{
  background: #1e82e8;
  text-align: left;
  padding: 8px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/home-work/work/UploadHomeworkDialog.vue